export enum BlogStateEnum {
    list, 
    detail, 
    add,
    update
  }